import { useEffect, useState } from 'react';
import useViewer from '@hooks/useViewer';

const useMemberFields = memberData => {
    const { viewer } = useViewer();
    const [memberId, setMemberId] = useState();
    const [firstName, setFirstName] = useState();
    const [middleName, setMiddleName] = useState();
    const [lastName, setLastName] = useState();
    const [email, setEmail] = useState();
    const [company, setCompany] = useState();
    const [address, setAddress] = useState();
    const [city, setCity] = useState();
    const [stateProvince, setStateProvince] = useState();
    const [zip, setZip] = useState();
    const [countryID, setCountryID] = useState();

    // Effects
    useEffect(() => {
        setMemberId(viewer ? viewer.recordId : memberData?.id);
        setFirstName(viewer ? viewer.firstName : memberData?.first_name);
        setMiddleName(viewer ? viewer.middleName : memberData?.middle_name);
        setLastName(viewer ? viewer.lastName : memberData?.last_name);
        setEmail(viewer ? viewer.email : memberData?.email);
        setCompany(viewer ? viewer.nonmemberCompany : memberData?.nonmember_company);

        const mainAddress = viewer ? viewer.addresses.find(({ purpose }) => purpose === 'main') : null;
        const newAddress = memberData ? memberData.addresses.find(({ purpose }) => purpose === 'main') : null;

        setAddress(mainAddress ? mainAddress.address : newAddress?.address);
        setCity(mainAddress ? mainAddress.city : newAddress?.city);
        setStateProvince(mainAddress ? mainAddress.stateProvince : newAddress?.state_province);
        setZip(mainAddress ? mainAddress.zip : newAddress?.zip);
        setCountryID((mainAddress ? mainAddress.country : newAddress?.country) || 'US');
    }, [viewer, memberData]);

    return {
        memberId,
        firstName,
        middleName,
        lastName,
        email,
        address,
        city,
        stateProvince,
        zip,
        countryID,
        company,
        setCountryID,
        setCompany,
        setStateProvince,
    };
};

export default useMemberFields;
